<template>
  <transition name="fade">
    <div class="balance" v-if="visible">
      <div class="balance-shadow" @click="hideCoinBalancePopup"></div>
      <div class="balance-main">
        <a
          href="javascript:;"
          class="main-close"
          @click="hideCoinBalancePopup"
        ></a>
        <div class="main-content">
          <p class="cur">
            <span class="cur-title">{{ getCoinsName }}{{ letter.remain }}</span>
            <span class="cur-coin">{{
              curCoinAmount >= 0 ? curCoinAmount : 0
            }}</span>
            <span class="cur-unit">{{ curCoinCurrency }}</span>
          </p>
          <p class="tip">{{ letter.balanceNotEnoggh }}</p>
          <div class="btn">
            <a href="javascript:;" class="btn-pay" @click="toCoinsPay">{{
              letter.goToPay
            }}</a>
            <a
              href="javascript:;"
              class="btn-change"
              @click="hideCoinBalancePopup"
              >{{ letter.chooseOtherPay }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  GET_BALANCE_INIT_DATA,
  GET_BALANCE_USER_DATA,
  getAreaByCurrency
} from '@store/officialStore/coins';

export default {
  name: 'CoinsBalancePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      curCoinAmount: state => state.coins.curCoinAmount,
      curCoinCurrency: state => state.coins.curCoinCurrency,
      letter: state => state.letter
    }),
    ...mapGetters(['getCoinsName'])
  },
  methods: {
    hideCoinBalancePopup() {
      this.$emit('update:visible', false);
    },
    async toCoinsPay() {
      this.hideCoinBalancePopup();
      await this.$store.dispatch(GET_BALANCE_INIT_DATA, {
        location: getAreaByCurrency(this.curCoinCurrency)
      });
      await this.$store.dispatch(GET_BALANCE_USER_DATA);
      this.$router.push({ name: 'coins' });
    }
  }
};
</script>

<style lang="scss" scoped>
.balance {
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
    transform: scale3d(1, 1, 1) translateZ(0) !important;
    transition: 0 !important;
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('coins-balance-bg.png');
  }

  .main {
    &-close {
      position: absolute;
      right: 46px;
      top: 36px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('close.png');
    }
    &-content {
      .cur {
        margin-top: 100px;
        margin-bottom: 26px;
        font-weight: bold;
        text-align: center;
        color: #fff;
        > span {
          display: inline-block;
        }
        &-title {
          font-size: 34px;
        }
        &-coin {
          margin-right: 10px;
          font-size: 56px;
          color: #c1a15e;
        }
        &-unit {
          font-size: 30px;
        }
      }
      .tip {
        height: 80px;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        color: #fff;
      }
      .btn {
        text-align: center;
        > a {
          font-size: 30px;
          text-align: center;
          color: #fff;
        }
        &-pay {
          display: block;
          margin: 0 auto 22px;
          line-height: 81px;
          @psetbg ('coins-balance-pay.png');
        }
        &-change {
          display: inline-block;
          padding-bottom: 4px;
          border-bottom: 1px solid #fff;
          // margin-bottom: 22px;
          // @psetbg ('coins-balance-paytype.png');
        }
      }
    }
  }
}
</style>
